<template>
    <div class="form-group" :id="this.idInput+'_div'" :key="componentKey">
        <div class="position-relative">
            <input
                type="text"
                :inputmode="this.inputMode"
                class="form-control form-control-sm input-text"
                :class="{'is-invalid': errorMessage}"
                :value="modelValue"
                :placeholder="this.inputPlaceHolder"
                ref="myInput"
                @keydown.enter="enterKey"
                autocomplete="off"
                :id="this.idInput"
                autofocus="on"
                @input="handleInput"
            />
            <div class="hidden-text" id="hiddenText"></div>
            <em @click="changeInputMode" :class="this.inputIcon"></em>
            <em @click="abrirScan" class="fa fa-camera text-secondary icon-cam"></em>
        </div>
        <div class="text-center text-danger mt-1 w-100" v-if="errorMessage">
            {{ errorMessage }}
        </div>
        <Modal
            :id="'scanModal_'+this.idInput"
            :title="this.titleScan"
            :buttonList="[]"
            :cancelFunction="fecharScan"
        >
            <StreamBarcodeReader v-if="scanAberto" @decode="onDecode" @loaded="onLoaded" @error="onError"></StreamBarcodeReader>
        </Modal>
    </div>
  </template>
  
<script>
    import $ from "jquery";
    import Modal from "../components/Modal.vue";
    import { StreamBarcodeReader } from "vue-barcode-reader";
    import { enterKey } from "../utils";

    export default {
        name: "InputDefaultApp",
        components: {
            Modal,
            StreamBarcodeReader,
        },

        props: {
            toUpperCase: {
                type: Boolean,
                default: false,
            },
            enterKey: {
                type: Function,
                default: function (e) {
                    enterKey(e);
                },
            },
            idInput: {
                type: String,
                default: "",
            },
            inputPlaceHolderSufixo: {
                type: String,
                default: "",
            },
            titleScan: {
                type: String,
                default: "",
            },
            typeInputMode: {
                type: String,
                default: "none",
            },
            errorMessage: {
                type: String,
                default: null,
            },
            value: {
                type: [String, Number],
                default: '',
            },
        },
        data() {
            return {
                scanAberto: false,
                modelValue: '',
                isInvalid: false,
                inputMode: 'none',
                inputPlaceHolder: 'Bipe ',
                inputIcon: 'fa fa-keyboard text-secondary icon-input',
                componentKey: Date.now() // Chave inicial
            };
        },
        async mounted() {
            this.inputPlaceHolder += this.inputPlaceHolderSufixo.replace("Digite ", "").replace("Bipe ", "");
            this.modelValue = this.value;
        },

        methods: {
            handleInput(event) {
                let newValue = null
                if (this.toUpperCase) {
                    newValue = event.target.value.toUpperCase();
                } else {
                    newValue = event.target.value;
                }
                this.modelValue = newValue
                this.$emit('input', newValue);  // Emite o valor atualizado para o v-model
            },
            abrirScan() {
                this.scanAberto = true;
                $("#scanModal_"+this.idInput).modal("show");
            },
            fecharScan() {
                this.scanAberto = false;
                $("#scanModal_"+this.idInput).modal("hide");
            },
            onDecode(r) {
                this.modelValue = r;

                this.fecharScan();

                setTimeout(() => {
                    this.$emit('displayScanFunction', r);
                }, 1000);
            },

            onError() {
                this.errorGeral = ("Não foi possível escanear")
            },
            onLoaded() {
                console.log("Scaneando código de barras ou QR Code!");
            },

            changeInputMode() {
                let inputMode = this.inputMode;

                if (inputMode === 'none') {
                    this.inputMode = this.typeInputMode;
                    this.inputPlaceHolder = 'Digite ' + this.inputPlaceHolderSufixo.replace("Digite ", "").replace("Bipe ", "");
                    this.inputIcon= 'fa fa-barcode text-secondary icon-input';
                } else {
                    this.inputMode = 'none';
                    this.inputPlaceHolder= 'Bipe ' + this.inputPlaceHolderSufixo.replace("Digite ", "").replace("Bipe ", "");
                    this.inputIcon= 'fa fa-keyboard text-secondary icon-input';
                }

                this.$refs.myInput.focus();
            },
        },
        resetComponent() {
            // Alterar a chave para forçar a recriação do componente
            this.componentKey = Date.now();
        },
        watch: {
            value(newValue) {
                this.modelValue = newValue;
            },
        },
    };
</script>
  
<style scoped>
    .form-control.is-invalid {
        border-color: red;
        background-image: none;
    }

    .icon-input {
        position: absolute;
        top: 20%;
        right: 30px;
        font-size: 18px;
    }

    .icon-cam {
        position: absolute;
        top: 20%;
        right: 5px;
        font-size: 18px;
    }

    .input-wrapper {
        position: relative;
        display: inline-block;
    }

    .input-text {
        width: 100%;
        box-sizing: border-box;
        padding-right: 20%;
    }

    .hidden-text {
        position: absolute;
        top: 0;
        right: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 20%;
        height: 90%;
        margin: 1px;
        background: #fff;
    }
</style>
  